import React, { useEffect, createElement } from 'react';
import { HeroHighlight } from '../components/ui/HeroHighlight';
export function ThankYouPage() {
  useEffect(() => {
    {
      // Initialize Facebook Pixel if not already initialized
      if (!window.fbq) {
        // Meta Pixel Code
        ;
        (function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          // Safe insertion - use head or documentElement
          const head = b.getElementsByTagName('head')[0] || b.documentElement;
          head.appendChild(t);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', '2114526969072924');
        window.fbq('track', 'PageView');
      }
    }
    // Add noscript pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2114526969072924&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Track conversion events
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead');
      window.fbq('track', 'CompleteRegistration');
      window.fbq('trackCustom', 'ApplicationCompleted');
      console.log('Thank you page conversion events tracked');
    }
    // Cleanup function to remove noscript element when component unmounts
    return () => {
      const noscriptElements = document.querySelectorAll('noscript');
      noscriptElements.forEach(element => {
        if (element.innerHTML.includes('facebook.com/tr')) {
          element.remove();
        }
      });
    };
  }, []);
  return <div className="w-full min-h-screen" data-id="element-119">
      <HeroHighlight data-id="element-120">
        <main className="max-w-6xl mx-auto px-4 flex flex-col items-center justify-center min-h-screen" data-id="element-121">
          <div className="text-center max-w-4xl mx-auto" data-id="element-122">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-8 text-white leading-[1.2]" data-id="element-123">
              Thank you for completing your virtual application!
            </h1>
            <p className="text-lg sm:text-xl text-white/80 mb-16" data-id="element-124">
              A member from our team will review your answers and get back to
              you with next steps.
            </p>
            <div className="flex justify-center" data-id="element-125">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b2kw2oJmb8JUi9aYWVqUFj/pasted-image.png" alt="SVRN PRO Logo" className="h-16" data-id="element-126" />
            </div>
          </div>
        </main>
      </HeroHighlight>
    </div>;
}
// Add TypeScript declarations for Facebook Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}